module.exports = __webpack_public_path__ + "img/73.acfb3e4d.png";